
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})

export default class PageTitle extends Vue {
  @Prop({ default: false })
  private readonly isCentered!: boolean;
}

